import React, { useState, useRef } from 'react';
import './FormResponsesComponents.scss';

interface FormGroup {
	id: string;
	title: string;
}

interface FormGroupTabsProps {
	formGroups: FormGroup[];
	activeTabId: string;
	onTabChange: (tabId: string) => void;
}

export const FormGroupTabs: React.FC<FormGroupTabsProps> = ({
	formGroups,
	activeTabId,
	onTabChange,
}) => {
	const scrollContainerRef = useRef<HTMLDivElement>(null);
	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);
	const [scrollLeft, setScrollLeft] = useState(0);

	if (formGroups.length <= 1) {
		return null;
	}

	const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
		if (!scrollContainerRef.current) {
			return;
		}
		setIsDragging(true);
		setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
		setScrollLeft(scrollContainerRef.current.scrollLeft);
		scrollContainerRef.current.style.cursor = 'grabbing';
	};

	const onMouseLeave = () => {
		if (!scrollContainerRef.current) {
			return;
		}
		setIsDragging(false);
		scrollContainerRef.current.style.cursor = 'grab';
	};

	const onMouseUp = () => {
		if (!scrollContainerRef.current) {
			return;
		}
		setIsDragging(false);
		scrollContainerRef.current.style.cursor = 'grab';
	};

	const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
		if (!isDragging || !scrollContainerRef.current) {
			return;
		}
		e.preventDefault();
		const x = e.pageX - scrollContainerRef.current.offsetLeft;
		const walk = (x - startX) * 2;
		scrollContainerRef.current.scrollLeft = scrollLeft - walk;
	};

	return (
		<div className="form-group-tabs-container">
			<div
				className="form-group-tabs-scroll"
				ref={scrollContainerRef}
				onMouseDown={onMouseDown}
				onMouseLeave={onMouseLeave}
				onMouseUp={onMouseUp}
				onMouseMove={onMouseMove}
			>
				{formGroups.map((group) => (
					<button
						key={group.id}
						onClick={() => onTabChange(group.id)}
						className={`form-group-tab ${activeTabId === group.id ? 'active' : ''}`}
					>
						{group.title}
					</button>
				))}
			</div>
		</div>
	);
};
